//import check from "../../src/images/check.png";
//import { Link, useLocation } from "react-router-dom";
//import { motion } from "framer-motion";
//import { useEffect } from "react";
//import {useSettings} from "../context/SettingsContext";
//import { t } from "context/translations";
//const ConfirmOrder = () => {
//  const { theme, language } = useSettings();
//  const isDark = theme === "dark";
//
//  return (
//    <div className={`min-h-[90dvh] flex items-center justify-center px-4 ${
//    isDark
//      ? "bg-gradient-to-br from-slate-900 via-slate-800 to-slate-950"
//      : "bg-gradient-to-br from-[#F9FAFB] to-[#EEF2FF]"
//}`}>
//      <motion.div
//        initial={{ opacity: 0, scale: 0.9, y: 20 }}
//        animate={{ opacity: 1, scale: 1, y: 0 }}
//        transition={{ duration: 0.5, ease: "easeOut" }}
//        className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 md:p-8 text-center"
//      >
//        {/* Success Icon */}
//        <motion.img
//          src={check}
//          alt="Order Confirmed"
//          className="w-24 md:w-32 mx-auto"
//          initial={{ scale: 0 }}
//          animate={{ scale: 1 }}
//          transition={{ delay: 0.2, type: "spring" }}
//        />
//
//        {/* Title */}
//        <h2 className={`mt-6 text-lg md:text-xl font-bold ${isDark?"text-white":"text-gray-800"}`}>
//          {t("ConfirmOrder", language)} 🎉
//        </h2>
//
//        {/* Message */}
//        <p className="mt-3 text-sm md:text-base text-gray-600 leading-relaxed">
//          {t("orderReceived", language)} <br />
//          {t("ourAgentContact", language)} 💖
//        </p>
//
//        {/* Divider */}
//        <div className="my-5 h-px bg-gray-200" />
//
//        {/* Action Button */}
//        <Link
//          to="/"
//          className="inline-block w-full bg-backgroundColor hover:bg-opacity-90 transition text-white py-3 rounded-lg text-xs font-semibold"
//        >
//          {t("ClickForMoreOrder", language)}
//        </Link>
//
//        {/* Small Note */}
//        <p className="mt-4 text-xs text-gray-400">
//          {t("thanksForOrder", language)} 💕
//        </p>
//      </motion.div>
//    </div>
//  );
//};
//
//export default ConfirmOrder;

import check from "../../src/images/check.png";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect } from "react";
import {useSettings} from "../context/SettingsContext";
import { t } from "context/translations";
const ConfirmOrder = () => {
  const { theme, language } = useSettings();
  const isDark = theme === "dark";

  return (
    <div className={`min-h-[90dvh] flex items-center justify-center px-4 ${
    isDark
      ? "bg-gradient-to-br from-slate-900 via-slate-800 to-slate-950"
      : "bg-gradient-to-br from-[#F9FAFB] to-[#EEF2FF]"
}`}>
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 md:p-8 text-center"
      >
        {/* Success Icon */}
        <motion.img
          src={check}
          alt="Order Confirmed"
          className="w-24 md:w-32 mx-auto"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
        />

        {/* Title */}
        <h2 className={`mt-6 text-lg md:text-xl font-bold ${isDark?"text-white":"text-gray-800"}`}>
          {t("ConfirmOrder", language)} 🎉
        </h2>

        {/* Message */}
        <p className="mt-3 text-sm md:text-base text-gray-600 leading-relaxed">
          {t("orderReceived", language)} <br />
          {t("ourAgentContact", language)} 💖
        </p>

        {/* Divider */}
        <div className="my-5 h-px bg-gray-200" />

        {/* Action Button */}
        <Link
          to="/"
          className="inline-block w-full bg-backgroundColor hover:bg-opacity-90 transition text-white py-3 rounded-lg text-xs font-semibold"
        >
          {t("ClickForMoreOrder", language)}
        </Link>

        {/* Small Note */}
        <p className="mt-4 text-xs text-gray-400">
          {t("thanksForOrder", language)} 💕
        </p>
      </motion.div>
    </div>
  );
};

export default ConfirmOrder;
